import * as yup from 'yup';
import { TranslationKey } from '../functions/translate';

export type ErrorKeys = TranslationKey[] | null;

/**
 * Define validation schema for strings - note that errors are returned in the order
 * that schema requirements are defined, meaning that the order of schema requirements
 * also defines the error message precedence.
 */
export class StringSchema {
    private schema = yup.string();

    required(error: TranslationKey) {
        this.schema = this.schema.required(error);
        return this;
    }

    min(min: number, error: TranslationKey) {
        this.schema = this.schema.min(min, error);
        return this;
    }

    max(max: number, error: TranslationKey) {
        this.schema = this.schema.max(max, error);
        return this;
    }

    betweenLength(min: number, max: number, error: TranslationKey) {
        this.min(min, error);
        return this.max(max, error);
    }

    matches(regex: RegExp, error: TranslationKey) {
        this.schema = this.schema.matches(regex, error);
        return this;
    }

    test(testName: string, error: TranslationKey, testFn: yup.TestFunction<string | undefined>) {
        this.schema = this.schema.test(testName, error, testFn);
        return this;
    }

    validate(value: string): ErrorKeys {
        try {
            this.schema.validateSync(value, { abortEarly: false }); // return all errors, not just first
            return null;
        } catch (e) {
            const error = e as yup.ValidationError;
            const allErrors = error.errors as TranslationKey[];
            return [...new Set(allErrors)];
        }
    }
}